import cx from "classnames";
import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { CircleButtonBackground } from "@gaming/xds-react-js-icons";

import { useProgramBackgroundColorPicker } from "../../../helpers/useProgramColorPicker";
import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./CircleIcon.module.css";

export const CircleIcon = () => {
  const colorStyle = useProgramBackgroundColorPicker();
  const [circleIcon] = useStrings("circleIcon");
  return (
    <Icon
      aria-hidden="true"
      className={cx(styles.circleIcon, colorStyle)}
      icon={CircleButtonBackground}
      title={circleIcon}
      iconSize={IconSize.Custom}
    />
  );
};
